<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" max-width="350px" :persistent="saving">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span v-if="isNew" class="headline">Transliteration for "{{ letter.uppercase }} {{ letter.lowercase }}"</span>
          <span v-if="!isNew" class="headline">Transliteration for "{{ letter.uppercase }} {{ letter.lowercase }}"</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="showErrorOnSave" type="error">{{ errorOnSave }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                        v-model.trim="edited.name"
                        required
                        :rules="[required]"
                        label="Transliteration"
                        :error-messages="errorMessages"
                        :disabled="saving"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save" :loading="saving">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { TransliteratedLetterApi } from '../common/api'
import {
  ADD_TRANSLITERATED_LETTER,
  UPDATE_TRANSLITERATED_LETTER
} from '../store/mutation-types'
import { mapGetters } from 'vuex'

const COMMON_ERROR = 'Error has occurred while saving'

export default {
  props: ['value', 'model'],
  data () {
    return {
      valid: false,
      saving: false,
      errorMessages: [],
      errorOnSave: COMMON_ERROR,
      showErrorOnSave: false,
      edited: this.defaultModel()
    }
  },
  computed: {
    isNew () {
      return !this.transliteratedLetter.id
    },
    letter () {
      return this.model || {}
    },
    transliteratedLetter () {
      return this.model && this.model.transliteratedLetter ? this.model.transliteratedLetter : {}
    },
    ...mapGetters([
      'targetLanguageId'
    ])
  },
  watch: {
    value () {
      this.showErrorOnSave = false
      this.$refs.form.resetValidation()
      if (!this.value) {
        return
      }
      if (this.isNew) {
        this.edited = this.defaultModel()
      } else {
        this.edited = { ...this.transliteratedLetter }
      }
    }
  },
  methods: {
    defaultModel () {
      return {
        name: null,
        languageId: this.targetLanguageId
      }
    },
    validate () {
      this.errorOnSave = COMMON_ERROR
      return this.$refs.form.validate()
    },
    close () {
      if (this.saving) {
        return
      }
      this.$emit('input', false)
    },
    async save () {
      if (this.saving) {
        return
      }
      if (!this.validate()) {
        return
      }
      this.showErrorOnSave = false
      this.saving = true
      try {
        const letter = this.letter
        if (this.isNew) {
          const { data } = await TransliteratedLetterApi.create(letter, this.edited)
          this.$store.commit(ADD_TRANSLITERATED_LETTER, { letter, transliteratedLetter: data })
        } else {
          const { data } = await TransliteratedLetterApi.update(letter, this.edited)
          this.$store.commit(UPDATE_TRANSLITERATED_LETTER, { letter, transliteratedLetter: data })
        }
        this.saving = false
        this.close()
      } catch (e) {
        this.saving = false
        this.showErrorOnSave = true
        console.error(e)
      }
    },
    required (value) {
      return !!value || 'Required.'
    }
  }
}
</script>
